module.exports = __webpack_public_path__ + "img/logo.ebc40dde.svg";